import { Select } from '@/core/ui';
import { styled } from '@mui/material';
export const SelectStyled = styled(Select)({
    minWidth: '140px',
});
